import gql from "../gql";
export default gql `
  mutation ToggleHireMe($isAvailableForHire: Boolean!) {
    toggleHireMe(input: { isAvailableForHire: $isAvailableForHire }) {
      __typename
      success
    }
  }
`;
